import { render, staticRenderFns } from "./rest_tickets.vue?vue&type=template&id=6d15a99a&"
import script from "./rest_tickets.vue?vue&type=script&lang=js&"
export * from "./rest_tickets.vue?vue&type=script&lang=js&"
import style0 from "./rest_tickets.vue?vue&type=style&index=0&id=6d15a99a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports